import axios, { AxiosResponse } from "axios";
import {
  throwSylaApiError,
  parseProblemFromBlob,
} from "../errors/throwSylaApiError";

export async function downloadHoldingStatementCsv({
  accountId,
  byAsset,
  marketValue,
  balanceDate,
}: {
  accountId: string;
  byAsset: boolean;
  marketValue: boolean;
  balanceDate?: Date;
}): Promise<void> {
  let response: AxiosResponse<Blob>;
  try {
    response = await axios.get(
      `/accounts/${accountId}/download-holding-statements-csv`,
      {
        params: { byAsset, marketValue, balanceDate },
        responseType: "blob",
      },
    );
  } catch (error) {
    throwSylaApiError(await parseProblemFromBlob(error));
  }

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(response.data);
  link.setAttribute(
    "download",
    response.headers["content-disposition"]?.match(/filename="(.*)"/)?.at(1) ??
      `Syla Holding Statement.csv`,
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return;
}
